module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "col": "12",
      "justify-center": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n          Usage\n        ")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Total Users: " + _vm._s(_vm.users))]), _vm._v(" "), _c('p', [_vm._v("Total Images: " + _vm._s(_vm.images))]), _vm._v(" "), _c('p', [_vm._v("Total Storage: " + _vm._s(_vm.storage) + " GB")]), _vm._v(" "), (_vm.showPrice) ? [_c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Price / User / month: $" + _vm._s(_vm.formatDollars(_vm.configuration.pricePerUser)))]), _vm._v(" "), _c('p', [_vm._v("Price / GB / month: $" + _vm._s(_vm.formatDollars(_vm.configuration.pricePerGB)))]), _vm._v(" "), _c('p', [_vm._v("Base Price: $" + _vm._s(_vm.formatDollars(_vm.configuration.priceBase)))]), _vm._v(" "), _c('p', [_vm._v("GB / user / month: " + _vm._s(_vm.configuration.storagePerUser))]), _vm._v(" "), _c('p', [_vm._v("GB base: " + _vm._s(_vm.configuration.storageBase))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("Total Price: $" + _vm._s(_vm.formatDollars(_vm.priceTotal)))]), _vm._v(" "), _c('p', [_vm._v("Users Price: $" + _vm._s(_vm.formatDollars(_vm.priceUsers)))]), _vm._v(" "), _c('p', [_vm._v("Storage Alloted: " + _vm._s(_vm.storageAlloted) + " GB")]), _vm._v(" "), _c('p', [_vm._v("Storage Free: " + _vm._s(_vm.storageFree) + " GB")]), _vm._v(" "), _c('p', [_vm._v("Storage Overage: " + _vm._s(_vm.storageOverage) + " GB")]), _vm._v(" "), _c('p', [_vm._v("Storage Price: $" + _vm._s(_vm.formatDollars(_vm.priceStorage)))])] : _vm._e()], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63e3bd17","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Usage.vue
// module id = 432
// module chunks = 1